import cloneDeep from 'lodash.clonedeep';

const initialState = {
    undo: [],
    redo: [],
    renderId: ""
}

// const initialState = {
//     undo: [
//         {
//             "item": {
//                 "name": "http2",
//                 "id": "aUW5V2hgg3uQLNurhBak6p-201",
//                 "type": 1,
//                 "position": {
//                     "x": 149,
//                     "y": 366.8639639639639
//                 },
//                 "attributes": {
//                     "type": "http2_delegate",
//                     "desc": "abcdefg",
//                     "network": "b5RPdNhfWD3QgcBm6fy9YQ"
//                 }
//             },
//             "undo": "UNDO_EDIT_CLUSTERLET",
//             "redo": "REDO_EDIT_CLUSTERLET",
//             "id": "rJtfTtvg2iUzL3i5nSAKff",
//             "user": "63157a0de7ce370068b50747",
//             "blueprint": 29,
//             "dependencies": {
//                 "edited": {
//                     "name": "http2",
//                     "id": "aUW5V2hgg3uQLNurhBak6p-201",
//                     "type": 1,
//                     "position": {
//                         "x": 149,
//                         "y": 366.8639639639639
//                     },
//                     "attributes": {
//                         "type": "http2_delegate",
//                         "desc": "abcdefg",
//                         "network": "b5RPdNhfWD3QgcBm6fy9YQ"
//                     }
//                 },
//                 "original": {
//                     "name": "http2",
//                     "id": "aUW5V2hgg3uQLNurhBak6p-201",
//                     "type": 1,
//                     "position": {
//                         "x": 149,
//                         "y": 366.8639639639639
//                     },
//                     "attributes": {
//                         "type": "http2_delegate",
//                         "desc": "",
//                         "network": "b5RPdNhfWD3QgcBm6fy9YQ"
//                     }
//                 },
//                 "editedrrdefs":[{
//             "id": "9dhq43kUaYhbKaQzNDcW8X",
//             "type": 13,
//             "name": "editedrrrdef",
//             "attributes": {
//                 "name": "editedrrrdef",
//                 "dir": "IN",
//                 "path": "a/p/a",
//                 "code": "200",
//                 "tinstance": "{sensor123}",
//                 "op": "PUT",
//                 "ttype": "fQa9dJJoCXfXMduepUd1tq-301",
//                 "tcmd": "fF3M5tHJzEDQec8bme96VM",
//                 "parameters": [
//                     {
//                         "type": "param",
//                         "value": "value"
//                     }
//                 ],
//                 "delegate": "aUW5V2hgg3uQLNurhBak6p-201"
//             }
//         }],
//         "originalrrdefs":[{
//             "id": "sxnBUoDfQ1dYbGb42",
//             "type": 13,
//             "name": "originalrrrdef",
//             "attributes": {
//                 "name": "originalrrrdef",
//                 "dir": "IN",
//                 "path": "a/p/a",
//                 "code": "200",
//                 "tinstance": "{sensor123}",
//                 "op": "PUT",
//                 "ttype": "fQa9dJJoCXfXMduepUd1tq-301",
//                 "tcmd": "fF3M5tHJzEDQec8bme96VM",
//                 "parameters": [
//                     {
//                         "type": "param",
//                         "value": "value"
//                     }
//                 ],
//                 "delegate": "aUW5V2hgg3uQLNurhBak6p-201"
//             }
//         }],
//             }
//         }
//     ],
//     redo: [],
//     renderId: ""
// }

/*

activity
const activity = {
   id,
   type : { undo : '', redo: '' },
   user,
   blueprint,
   item,
   created,
   associated,
   prevIndex // if a transaction is removed, on undo it should be on the same order from where its removed
}

*/

export default function appReducer(state = initialState, action) {

    switch (action.type) {

        case 'ADD_UNDO': {

            return {
                ...state,
                undo: [
                    ...state.undo,
                    { ...action.payload }
                ],
                // renderId: action.payload.renderId
            }
        }

        case 'ADD_REDO': {
            return {
                ...state,
                redo: [
                    ...state.redo,
                    { ...action.payload }
                ],
                // renderId: action.payload.renderId
            }
        }

        case 'POP_UNDO': {
            return {
                ...state,
                undo: state.undo.filter(item => item.id !== action.payload.id)
                // renderId: action.activity.renderId
            }
        }

        case 'POP_REDO': {
            return {
                ...state,
                redo: state.redo.filter(item => item.id !== action.payload.id)
                // redo: state.redo.filter(item => item.id != action.activity.id),
                // renderId: action.activity.renderId
            }
        }

        case 'UPDATE_UNDO': {
            return {
                ...state,
                undo: [
                    ...state.undo,
                    ...action.payload,
                ],

            }
        }

        case 'UPDATE_REDO': {
            return {
                ...state,
                redo: [
                    ...state.redo,
                    ...action.payload
                ],
            }
        }

        case 'UPDATE_POSITION':
            let newState = state

            newState.undo.forEach(element => {
                if(element?.item?.id === action?.payload?.id) element.item.position = action.payload.position;                
            })

            newState.redo.forEach(element => {
                if(element?.item?.id === action?.payload?.id) element.item.position = action.payload.position;                
            })
   
            return {
                ...state,
                undo: newState.undo,
                redo: newState.redo
            }

            break;

        case 'RESET_UNDOREDO':
            return cloneDeep(initialState);
            break;

        default:
            return state
    }

}